export * from './layer.service';
export * from './layers';
export * from './style.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/layer/shared/index.ts